import Vue from 'vue'
import App from './App.vue'
import router from './router'

import {BootstrapVue} from 'bootstrap-vue'
import VueYoutube from 'vue-youtube'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faVk } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


import Scrollspy from 'vue2-scrollspy';

var VueScrollTo = require('vue-scrollto');
import Toast from "vue-toastification";

Vue.config.productionTip = false

import "@/assets/scss/style.scss";
import "@/assets/css/materialdesignicons.min.css";

library.add(faVk)


Vue.use(VueYoutube)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Scrollspy);
Vue.use(VueScrollTo);
Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
});
// Install BootstrapVue
Vue.use(BootstrapVue)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
